import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AgregadorService } from '../services/agregador.service';

@Injectable({
  providedIn: 'root'
})
export class AgregadorResolver implements Resolve<boolean> {

  constructor(private service: AgregadorService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.idProjeto);
  }
}
